import { LOCALES } from "../locales";
export var getSupportArticleLink = function getSupportArticleLink(resolvedLanguage, id) {
  var lang = resolvedLanguage === LOCALES.ZH ? 'zh-cn' : 'en-us';
  return "https://support.tokenlon.im/hc/".concat(lang, "/articles/").concat(id);
};